import { Routes } from '@angular/router';
import { AuthGuard } from 'app/guards/auth-guard';
import { RoleGuard } from 'app/guards/role-guard';

export const ScripterRoutes: Routes = [
  {
    path: 'dashboard',
    loadComponent: () =>
      import('@pages/scripter/dashboard/dashboard').then((m) => m.Dashboard),
    data: {
      isSidebar: 1,
      isHeader: 1,
      // expectedRole: 'Scripter',
    },
  },
  {
    path: 'project-management',
    loadComponent: () =>
      import('@pages/scripter/project-management/project-management').then(
        (m) => m.ProjectManagement
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      // expectedRole: 'Scripter',
    },
  },
];
